// import React, { useEffect, useState } from "react";
// import axios from 'axios';
// import "../assets/FundApproval.css";

// const FundRequestApproval = () => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages,setTotalPages]=useState(1);
//   const [filters, setFilters] = useState({
//     fromDate: "",
//     toDate: "",
//     utr: "",
//     user: "",
//   });

//   const [requests, setRequests] = useState([]);
//     // { sn: 1, date: "2025-04-12", user: "Rajeev (MNG00004)", amount: 1000000, utr: "1212", status: "Pending" },
//     // { sn: 2, date: "2025-04-09", user: "Demo Agent (AGN00001)", amount: 100, utr: "1234567890-", status: "Pending" },
//     // { sn: 3, date: "2025-02-11", user: "AKASH (MNG00002)", amount: 40000, utr: "77452345", status: "Pending" },
//     // { sn: 4, date: "2025-01-21", user: "Demo Manager (MNG00001)", amount: 2000, utr: "5566gyuu7778", status: "Pending" },
//     // { sn: 5, date: "2025-01-15", user: "Demo Agent (AGN00001)", amount: 10000, utr: "23214234124", status: "Approved" },
//     // { sn: 6, date: "2025-01-01", user: "Rajeev (MNG00004)", amount: 10000, utr: "123456789", status: "Approved" }
  

//   const superAdminId=localStorage.getItem("adminuserId");
//   console.log("superadminid is ",superAdminId);
//   const getfundapproval = async() => {
//     try{
//         const res= await axios.get(`https://payyug.in/api/employe-fund-request/get-all?superAdminId=${superAdminId}`);
//         if(res.data.data){
//            setRequests(res.data.data);
//            setTotalPages(res.data.totalPages);
//         }
//     }
//     catch(error){
//       console.log(error);

//     }
//   }

//   useEffect (() => {
//     getfundapproval();
//   },[])

//   useEffect(()=> {
//     getfundapproval();
//   },[currentPage])

//   const [selectedRequest, setSelectedRequest] = useState(null);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [newStatus, setNewStatus] = useState("");

//   const handleChangeStatus = (request) => {
//     setSelectedRequest(request);
//     setModalOpen(true);
//   };

//   const confirmStatusChange = () => {
//     if (newStatus && selectedRequest) {
//       setRequests((prev) =>
//         prev.map((req) =>
//           req.sn === selectedRequest.sn ? { ...req, status: newStatus } : req
//         )
//       );
//     }
//     setModalOpen(false);
//     setSelectedRequest(null);
//     setNewStatus("");
//   };

 

//   return (
//     <div className="FundRequestApproval-container">
//       <h1 className="FundRequestApproval-title">Fund Request Approval</h1>

//       {/* Filter Section */}
//       {/* <div className="FundRequestApproval-filterSection">
//         <div>
//           <label>From Date</label>
//           <input type="date" placeholder="dd-mm-yyyy" />
//         </div>
//         <div>
//           <label>To Date</label>
//           <input type="date" placeholder="dd-mm-yyyy" />
//         </div>
//         <div>
//           <label>UTR Number</label>
//           <input type="text" placeholder="Enter UTR number" />
//         </div>
//         <div>
//           <label>User</label>
//           <select>
//             <option value="">Select User</option>
//             {/* <option>Rajeev (MNG00004)</option>
//             <option>Demo Agent (AGN00001)</option>
//             <option>AKASH (MNG00002)</option>
//             <option>Demo Manager (MNG00001)</option> */}
//           {/* </select>
//         </div>
//         <button className="FundRequestApproval-btn search">Search</button>
//       </div> */} 

//       {/* Table Section */}
//       <div className="FundRequestApproval-tableWrapper">
//         <h2 className="FundRequestApproval-subTitle">Request List</h2>
//         <table className="FundRequestApproval-table">
//           <thead>
//             <tr>
//               <th>S.N.</th>
//               <th>Date</th>
//               {/* <th>User</th> */}
//               <th>Amount</th>
//               {/* <th>UTR</th>
//               <th>Slip</th> */}
//               <th>Purpose</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {requests?.map((req,index) => (
//               <tr key={req.id}>
//                 <td>{index+1}</td>
//                 <td>{req.requestedAt ? new Date(req.requestedAt).toLocaleDateString("en-GB") : "N/A"}</td>
//                 {/* <td>{req.user}</td> */}
//                 <td>{req.amount ||"N/A"}</td>
//                 <td>{req.purpose||"N/A"}</td>
//                 <td>
//                   <span className={`FundRequestApproval-status ${req.status.toLowerCase()}`}>
//                     {req.status}
//                   </span>
//                 </td>
//                 <td className="fundapproval-action-button">
//                   <button className="fundapproval-approve">
//                     Approve
//                   </button>
//                   <button className="fundapproval-reject">
//                     Reject
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Modal */}
//       {modalOpen && selectedRequest && (
//         <div className="FundRequestApproval-modalOverlay" onClick={() => setModalOpen(false)}>
//           <div className="FundRequestApproval-modal" onClick={(e) => e.stopPropagation()}>
//             <h2>Update Status</h2>
//             <p><strong>User:</strong> {selectedRequest.user}</p>
//             <p><strong>Amount:</strong> ₹{selectedRequest.amount.toLocaleString()}</p>
//             <p><strong>Current Status:</strong> {selectedRequest.status}</p>

//             <label>Select New Status</label>
//             <select
//               value={newStatus}
//               onChange={(e) => setNewStatus(e.target.value)}
//               className="FundRequestApproval-select"
//             >
//               <option value="">Select</option>
//               <option value="Approved">Approved</option>
//               <option value="Hold">Hold</option>
//               <option value="Debit">Debit</option>
//             </select>

//             <div className="FundRequestApproval-modalButtons">
//               <button className="cancel" onClick={() => setModalOpen(false)}>Cancel</button>
//               <button className="update" onClick={confirmStatusChange}>Update</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* pagination */}
//       {totalPages >= 1 && (
//           <div className="LoanReport-pagination">
//             <button
//               disabled={currentPage === 1}
//               onClick={() => setCurrentPage((prev) => prev - 1)}
//             >
//               Previous
//             </button>
//             <span>
//               Page {currentPage} of {totalPages}
//             </span>
//             <button
//               disabled={currentPage === totalPages}
//               onClick={() => setCurrentPage((prev) => prev + 1)}
//             >
//               Next
//             </button>
//           </div>
//         )}

//     </div>
//   );
// };

// export default FundRequestApproval;


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
import axios from "axios";
import "../assets/FundApproval.css";

const API_URL = "https://payyug.in/api/";

const FundRequestApproval = () => {
  const dispatch = useDispatch();
  const { list: employeeList, loading: empLoading } = useSelector((state) => state.employeeReport);

  const [requests, setRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  // ── Filter state ─────────────────────────────────────────────────────────
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [filterApplied, setFilterApplied] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState("");

  // Approve modal state
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [branchLedgers, setBranchLedgers] = useState([]);
  const [selectedLedgerId, setSelectedLedgerId] = useState("");
  const [ledgerNames, setLedgerNames] = useState({}); // ledger_id -> name map
  const [ledgerLoading, setLedgerLoading] = useState(false);
  const [ledgerError, setLedgerError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // Reject modal state
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectRequest, setRejectRequest] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectSubmitting, setRejectSubmitting] = useState(false);

  const rowsPerPage = 10;
  const superAdminId = localStorage.getItem("adminuserId");

  // ── Fetch branches on mount ──
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const res = await axios.get(`${API_URL}get-branch`, {
          params: { SuperAdminId: superAdminId, limit: "all" },
        });
        setBranches(res.data.branches || []);
      } catch (err) {
        console.error("Branch fetch error:", err);
      }
    };
    fetchBranches();
  }, []);

  // ── Fetch all employees ────────
  useEffect(() => {
    dispatch(fetchEmployeeReport({ page: 1, pageSize: 100 }));
  }, [dispatch]);

  // ── Filter by selected branch ─────────
  const employees = employeeList
    ? employeeList.filter(
        (emp) => !selectedBranch || emp.branchId === selectedBranch.id
      )
    : [];


  // Reset employee when branch changes
  useEffect(() => {
    setSelectedEmployee("");
  }, [selectedBranch]);

  // ── Fetch fund requests ───
  const getFundApproval = async (page = currentPage) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${API_URL}employe-fund-request/get-all`,
        {
          params: {
            superAdminId,
            page,
            limit: rowsPerPage,
            ...(selectedBranch && { branchId: selectedBranch.id }),
            ...(selectedEmployee && { employeeId: selectedEmployee.id }),
            ...(selectedStatus && { status: selectedStatus }),
          },
        }
      );
      if (res.data) {
        setRequests(res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
        setTotalCount(res.data.totalRecords || 0);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filterApplied) getFundApproval(currentPage);
  }, [currentPage]);

  // ── Filter handlers ───
  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    setFilterApplied(true);
    getFundApproval(1);
  };

  const handleReset = () => {
    setSelectedBranch("");
    setSelectedEmployee("");
    setFilterApplied(false);
    setSelectedStatus("");
    setFilterApplied(false);
    setRequests([]);
    setTotalCount(0);
    setCurrentPage(1);
  };

  // ── Fetch branch ledgers + ledger names ─────
  const fetchBranchLedgers = async () => {
    setLedgerLoading(true);
    setLedgerError("");
    setBranchLedgers([]);
    try {
      // Fetch branch ledgers (same call as BranchLedgerList)
      const [blRes, lgRes] = await Promise.all([
        axios.get(`${API_URL}branch-ledger/get-all`, {
          params: { superAdminId, page: 1, limit: 100, status: "Active" },
        }),
        axios.get(`${API_URL}ledger/getall`, {
          params: { superAdminId },
        }),
      ]);

      const data = blRes.data?.data || blRes.data?.rows || (Array.isArray(blRes.data) ? blRes.data : []);
      const ledgers = lgRes.data?.rows || lgRes.data?.data || [];

      // Build a quick lookup map: ledger_id -> ledger name
      const nameMap = {};
      ledgers.forEach((lg) => { nameMap[lg.id] = lg.name; });
      setLedgerNames(nameMap);
      setBranchLedgers(data);

      if (data.length === 0) setLedgerError("No active branch ledgers found.");
    } catch (err) {
      setLedgerError("Could not load branch ledgers. Please try again.");
      console.error("Branch ledger fetch error:", err);
    } finally {
      setLedgerLoading(false);
    }
  };

  // ── Approve modal ────────────────────────────────────────────────────────
  const openApproveModal = (req) => {
    setSelectedRequest(req);
    setSelectedLedgerId("");
    setLedgerError("");
    setApproveModalOpen(true);
    fetchBranchLedgers();
  };

  const closeApproveModal = () => {
    setApproveModalOpen(false);
    setSelectedRequest(null);
    setBranchLedgers([]);
    setLedgerError("");
  };

  const handleApproveSubmit = async () => {
    if (!selectedLedgerId) {
      setLedgerError("Please select a branch ledger to proceed.");
      return;
    }
    setSubmitting(true);
    // Using PUT to match BranchLedgerList update pattern; payload uses snake_case to match API fields
    const payload = { status: "Approved", ledger_id: Number(selectedLedgerId), superAdminId };
    console.log("Approve payload ->", payload, "for id:", selectedRequest.id);
    try {
      await axios.post(
        `${API_URL}employe-fund-request/approve/${selectedRequest.id}`,
        payload
      );
      setRequests((prev) =>
        prev.map((r) =>
          r.id === selectedRequest.id ? { ...r, status: "Approved" } : r
        )
      );
      closeApproveModal();
    } catch (err) {
      const status = err?.response?.status;
      const msg = err?.response?.data?.message || err?.response?.data?.error;
      console.error("Approve API error:", err?.response);
      setLedgerError(
        status === 404
          ? "Endpoint not found (404) — confirm the correct route with your backend team."
          : msg || "Approval failed. Try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  // ── Reject modal ─────────────────────────────────────────────────────────
  const openRejectModal = (req) => {
    setRejectRequest(req);
    setRejectReason("");
    setRejectModalOpen(true);
  };

  const closeRejectModal = () => {
    setRejectModalOpen(false);
    setRejectRequest(null);
  };

  const handleRejectSubmit = async () => {
    setRejectSubmitting(true);
    try {
      await axios.post(
        `${API_URL}employe-fund-request/reject/${rejectRequest.id}`,
        { reason: rejectReason, superAdminId }
      );
      setRequests((prev) =>
        prev.map((r) =>
          r.id === rejectRequest.id ? { ...r, status: "Rejected" } : r
        )
      );
      closeRejectModal();
    } catch (err) {
      console.error(err);
    } finally {
      setRejectSubmitting(false);
    }
  };

  // ── Helpers ──────────────────────────────────────────────────────────────
  const getStatusClass = (status) => {
    const s = status?.toLowerCase();
    if (s === "approved") return "fra-status fra-status--approved";
    if (s === "rejected") return "fra-status fra-status--rejected";
    if (s === "pending")  return "fra-status fra-status--pending";
    return "fra-status fra-status--hold";
  };

  const getStatusIcon = (status) => {
    const s = status?.toLowerCase();
    if (s === "approved") return "✓";
    if (s === "rejected") return "✕";
    if (s === "pending")  return "◷";
    return "⏸";
  };

  return (
    <div className="fra-page">

      {/* ── Page Header ── */}
      <div className="fra-header">
        <div className="fra-header__icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="5" width="20" height="14" rx="2"/>
            <line x1="2" y1="10" x2="22" y2="10"/>
          </svg>
        </div>
        <div className="fra-header__text">
          <h1 className="fra-header__title">Fund Request Approval</h1>
          <p className="fra-header__sub">Select a branch and status to view requests</p>
        </div>
        {filterApplied && (
          <div className="fra-header__badge">
            <span className="fra-header__badge-num">{totalCount}</span>
            <span className="fra-header__badge-label">Total</span>
          </div>
        )}
      </div>

      {/* ── Filter Card ── */}
      <div className="fra-filter-card">
        <div className="fra-filter-card__head">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
          </svg>
          Filter Requests
        </div>

        <form className="fra-filter-form" onSubmit={handleFilterSubmit}>

          {/* Branch */}
          <div className="fra-filter-group">
            <label className="fra-filter-label">
              Select Branch <span className="fra-req">*</span>
            </label>
            <div className="fra-select-wrap">
              <select
                className="fra-select"
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const val = e.target.value;
                  const branchObj = branches.find((b) => b.id === Number(val));
                  setSelectedBranch(branchObj || "");
                  setSelectedEmployee(""); // reset employee on branch change
                  setFilterApplied(false);
                  setRequests([]);
                }}
                required
              >
                <option value="">— Select a branch —</option>
                {branches.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
              <span className="fra-select-arrow">▾</span>
            </div>
          </div>

          {/* Employee */}
          <div className="fra-filter-group">
            <label className="fra-filter-label">Select Employee</label>
            <div className="fra-select-wrap">
              <select
                className="fra-select"
                value={selectedEmployee?.id || ""}
                onChange={(e) => {
                  const val = e.target.value;
                  const empObj = employees.find((em) => em.id === Number(val));
                  setSelectedEmployee(empObj || "");
                }}
                disabled={!selectedBranch || empLoading}
              >
                <option value="">
                  {empLoading
                    ? "Loading employees..."
                    : !selectedBranch
                    ? "— Select branch first —"
                    : "All Employees"}
                </option>
                {employees.map((emp) => (
                  <option key={emp.id} value={emp.id}>
                    {emp.fullName}
                  </option>
                ))}
              </select>
              <span className="fra-select-arrow">▾</span>
            </div>
          </div>

          {/* Status */}
          <div className="fra-filter-group">
            <label className="fra-filter-label">Request Status</label>
            <div className="fra-select-wrap">
              <select
                className="fra-select"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="">All Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>
              <span className="fra-select-arrow">▾</span>
            </div>
          </div>

          {/* Buttons */}
          <div className="fra-filter-actions">
            <button type="submit" className="fra-filter-submit">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
              Search
            </button>
            {filterApplied && (
              <button type="button" className="fra-filter-reset" onClick={handleReset}>
                ✕ Reset
              </button>
            )}
          </div>

        </form>
      </div>

      {/* ── Empty state before filter applied ── */}
      {!filterApplied ? (
        <div className="fra-empty-state">
          <div className="fra-empty-state__icon">🔍</div>
          <p className="fra-empty-state__text">
            Select a branch and click <strong>Search</strong> to view fund requests
          </p>
        </div>
      ) : (
        <>
          {/* ── Table Card ── */}
          <div className="fra-card">
            <div className="fra-card__head">
              <h2 className="fra-card__title">Request List</h2>
              <span className="fra-card__sub">
                Branch: <strong>{selectedBranch?.name || ""}</strong>
                {selectedStatus && <> &nbsp;·&nbsp; Status: <strong>{selectedStatus}</strong></>}
              </span>
            </div>

            <div className="fra-table-wrap">
              <table className="fra-table">
                <thead>
                  <tr>
                    <th>S.N.</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Purpose</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={6} className="fra-table__state">
                        <div className="fra-dots">
                          <div /><div /><div />
                        </div>
                        <span>Loading requests…</span>
                      </td>
                    </tr>
                  ) : requests.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="fra-table__state">
                        <div className="fra-empty-icon">📋</div>
                        <p>No fund requests found.</p>
                      </td>
                    </tr>
                  ) : (
                    requests.map((req, index) => {
                      const isProcessed =
                        req.status?.toLowerCase() === "approved" ||
                        req.status?.toLowerCase() === "rejected";
                      return (
                        <tr key={req.id} className="fra-table__row">
                          <td className="fra-td fra-td--sn">
                            {(currentPage - 1) * rowsPerPage + index + 1}
                          </td>
                          <td className="fra-td">
                            {req.requestedAt
                              ? new Date(req.requestedAt).toLocaleDateString("en-GB", {
                                  day: "2-digit", month: "short", year: "numeric",
                                })
                              : "N/A"}
                          </td>
                          <td className="fra-td fra-td--amount">
                            ₹{Number(req.amount || 0).toLocaleString("en-IN")}
                          </td>
                          <td className="fra-td fra-td--purpose">
                            {req.purpose || "—"}
                          </td>
                          <td className="fra-td">
                            <span className={getStatusClass(req.status)}>
                              <span className="fra-status__dot" />
                              {req.status || "Pending"}
                            </span>
                          </td>
                          <td className="fra-td">
                            <div className="fra-actions">
                              <button
                                className="fra-btn fra-btn--approve"
                                onClick={() => openApproveModal(req)}
                                disabled={isProcessed}
                              >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                  <polyline points="20 6 9 17 4 12"/>
                                </svg>
                                Approve
                              </button>
                              <button
                                className="fra-btn fra-btn--reject"
                                onClick={() => openRejectModal(req)}
                                disabled={isProcessed}
                              >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                  <line x1="18" y1="6" x2="6" y2="18"/>
                                  <line x1="6" y1="6" x2="18" y2="18"/>
                                </svg>
                                Reject
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* ── Pagination ── */}
          {totalPages > 1 && (
            <div className="fra-pagination">
              <button
                className="fra-page-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                ← Previous
              </button>
              <span className="fra-page-info">
                Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
              </span>
              <button
                className="fra-page-btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next →
              </button>
            </div>
          )}
        </>
      )}

      {/* ══ APPROVE MODAL ══ */}
      {approveModalOpen && selectedRequest && (
        <div className="fra-overlay" onClick={closeApproveModal}>
          <div className="fra-modal" onClick={(e) => e.stopPropagation()}>

            <div className="fra-modal__header fra-modal__header--approve">
              <div className="fra-modal__hicon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <div>
                <h2 className="fra-modal__title">Approve Request</h2>
                <p className="fra-modal__subtitle">Select a branch ledger to credit funds</p>
              </div>
              <button className="fra-modal__close" onClick={closeApproveModal}>✕</button>
            </div>

            <div className="fra-modal__body">
              {/* Summary strip */}
              <div className="fra-summary">
                <div className="fra-summary__item">
                  <span className="fra-summary__label">Amount</span>
                  <span className="fra-summary__val fra-summary__val--green">
                    ₹{Number(selectedRequest.amount || 0).toLocaleString("en-IN")}
                  </span>
                </div>
                <div className="fra-summary__item">
                  <span className="fra-summary__label">Purpose</span>
                  <span className="fra-summary__val">{selectedRequest.purpose || "—"}</span>
                </div>
                <div className="fra-summary__item">
                  <span className="fra-summary__label">Date</span>
                  <span className="fra-summary__val">
                    {selectedRequest.requestedAt
                      ? new Date(selectedRequest.requestedAt).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
                      : "N/A"}
                  </span>
                </div>
              </div>

              {/* Branch Ledger Select */}
              <div className="fra-field">
                <label className="fra-field__label">
                  Branch Ledger <span className="fra-req">*</span>
                </label>

                {ledgerLoading ? (
                  <div className="fra-ledger-loading">
                    <div className="fra-spinner" />
                    <span>Fetching branch ledgers…</span>
                  </div>
                ) : (
                  <div className="fra-select-wrap">
                    <select
                      className="fra-select"
                      value={selectedLedgerId}
                      onChange={(e) => {
                        setSelectedLedgerId(e.target.value);
                        setLedgerError("");
                      }}
                    >
                      <option value="">— Choose a branch ledger —</option>
                      {branchLedgers.map((bl) => (
                        <option key={bl.id} value={bl.id}>
                          {ledgerNames[bl.ledger_id] || bl.ledger?.name || `Ledger #${bl.ledger_id}`}
                          {bl.branch_id ? `  ·  Branch ${bl.branch_id}` : ""}
                          {bl.openingAmt != null ? `  ·  ₹${Number(bl.openingAmt).toLocaleString("en-IN")}` : ""}
                        </option>
                      ))}
                    </select>
                    <span className="fra-select-arrow">▾</span>
                  </div>
                )}

                {ledgerError && (
                  <p className="fra-field__error">⚠ {ledgerError}</p>
                )}
              </div>
            </div>

            <div className="fra-modal__footer">
              <button className="fra-modal__cancel" onClick={closeApproveModal}>
                Cancel
              </button>
              <button
                className="fra-modal__submit fra-modal__submit--approve"
                onClick={handleApproveSubmit}
                disabled={submitting || ledgerLoading}
              >
                {submitting ? "Approving…" : "✓ Confirm Approve"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ══ REJECT MODAL ══ */}
      {rejectModalOpen && rejectRequest && (
        <div className="fra-overlay" onClick={closeRejectModal}>
          <div className="fra-modal" onClick={(e) => e.stopPropagation()}>

            <div className="fra-modal__header fra-modal__header--reject">
              <div className="fra-modal__hicon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </div>
              <div>
                <h2 className="fra-modal__title">Reject Request</h2>
                <p className="fra-modal__subtitle">This action cannot be undone</p>
              </div>
              <button className="fra-modal__close" onClick={closeRejectModal}>✕</button>
            </div>

            <div className="fra-modal__body">
              <div className="fra-summary">
                <div className="fra-summary__item">
                  <span className="fra-summary__label">Amount</span>
                  <span className="fra-summary__val fra-summary__val--red">
                    ₹{Number(rejectRequest.amount || 0).toLocaleString("en-IN")}
                  </span>
                </div>
                <div className="fra-summary__item">
                  <span className="fra-summary__label">Purpose</span>
                  <span className="fra-summary__val">{rejectRequest.purpose || "—"}</span>
                </div>
              </div>

              <div className="fra-field">
                <label className="fra-field__label">
                  Rejection Reason
                  <span className="fra-optional"> (optional)</span>
                </label>
                <textarea
                  className="fra-textarea"
                  placeholder="Provide a reason to help the requester understand…"
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  rows={4}
                />
              </div>
            </div>

            <div className="fra-modal__footer">
              <button className="fra-modal__cancel" onClick={closeRejectModal}>
                Cancel
              </button>
              <button
                className="fra-modal__submit fra-modal__submit--reject"
                onClick={handleRejectSubmit}
                disabled={rejectSubmitting}
              >
                {rejectSubmitting ? "Rejecting…" : "✕ Confirm Reject"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FundRequestApproval;